import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TextAlpha } from '@yonderland/andes-react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { TIMEZONE_BY_MARKET } from '../../../constants/GeneralConstants';
import { useAemConfig } from '@as-react/common-components';
dayjs.extend(utc);
dayjs.extend(timezone);
const STORE_CLOSE_CUTOFF = 60;
const SEPARATOR = ' · ';
export const StoreScheduleIndicator = ({ todaySchedule }) => {
    const { t } = useTranslation(I18N_NAMESPACES.store);
    const { market } = useAemConfig();
    const todayDate = dayjs().tz(TIMEZONE_BY_MARKET[market]);
    const todayTimeInMinutes = todayDate.hour() * 60 + todayDate.minute();
    const currentlyOpened = !todaySchedule.closed &&
        todayTimeInMinutes >= todaySchedule.openTimeInMinutes &&
        todayTimeInMinutes < todaySchedule.closeTimeInMinutes;
    const openingLaterToday = !todaySchedule.closed && todayTimeInMinutes < todaySchedule.openTimeInMinutes;
    const closesSoon = currentlyOpened && todaySchedule.closeTimeInMinutes - todayTimeInMinutes <= STORE_CLOSE_CUTOFF;
    if (closesSoon) {
        return (_jsxs(TextAlpha, { variant: "bodyM", children: [_jsx(TextAlpha, { variant: "bodyM", color: "warning", as: "span", children: t('store.closes_soon') }), SEPARATOR, t('store.closes_soon_at', { closingHour: todaySchedule.closingHour })] }));
    }
    if (currentlyOpened) {
        return (_jsxs(TextAlpha, { variant: "bodyM", children: [_jsx(TextAlpha, { variant: "bodyM", color: "success", as: "span", children: t('store.open') }), SEPARATOR, t('store.closes_at', { closingHour: todaySchedule.closingHour })] }));
    }
    if (openingLaterToday) {
        return (_jsxs(TextAlpha, { variant: "bodyM", children: [_jsx(TextAlpha, { variant: "bodyM", color: "error", as: "span", children: t('store.closed.txt') }), SEPARATOR, t('store.opens_at', { openingHour: todaySchedule.openingHour })] }));
    }
    return (_jsx(TextAlpha, { variant: "bodyM", color: "error", as: "span", children: t('store.closed.txt') }));
};
